/**
 * Public AI Planning – Experiment entry point at /ai/planning
 * Wraps PlanningChatPage with PublicHeader for unauthenticated users.
 * Per requirements: anyone can use it; free token allowance; sign-in required for save/download.
 * Authenticated users are redirected to the full app planning page (/tenant/planning).
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PublicHeader } from '@/components/public/PublicHeader';
import PlanningChatPage from '@/pages/ai/PlanningChatPage';
import { useAuth } from '@/state/auth/AuthProvider';

export const PublicPlanningPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate('/tenant/planning', { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading || isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1a5d2e]" />
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col overflow-hidden bg-gray-100">
      <PublicHeader />
      <main className="flex-1 flex flex-col min-h-0 overflow-hidden py-4">
        <PlanningChatPage />
      </main>
    </div>
  );
};
